import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { SlWapiService } from '../model/api-services/sl-wapi.service';
import { SandboxMessengerService } from '../services/sandbox-messenger.service';

@Injectable({ providedIn: 'root' })
export class SandboxedGuard implements CanActivate {
  constructor(
    private router: Router,
    private wapi: SlWapiService,
    private messenger: SandboxMessengerService
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    // 1) Make sure the sandbox channel is registered before we decide

    // 2) Remember the intended URL for later (e.g., after full auth)
    this.wapi.SetAuthTo(state.url);

    // 3) If we do not have *any* token yet, get a sandbox token and allow the route
    if (!SlWapiService.SLSESSION?.token) {
      try {
        await this.wapi.AuthenticateAsSandboxed(); // should set a non-privileged token
      } catch {
        // If sandbox auth itself fails, send user to login with returnUrl
        return this.router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
      }

      this.messenger.Register(state.url);
      return true; // allow route to load after sandbox authentication completes
    }

    // 4) A sandbox token is the authentication state; sandbox sessions do not use an auth cookie.
    if (SlWapiService.SLSESSION?.token) {
      this.messenger.Register(state.url);
      return true;
    }

    return this.router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
  }
}
